import { useEffect, useRef, useState } from "react";

export default function PromoCountdown({ startDate, durationDays }) {
    const [timeLeft, setTimeLeft] = useState(null);
    const [visible, setVisible] = useState(false);
    const countdownRef = useRef(null);

    const calculateTimeLeft = () => {
        const start = new Date(startDate).getTime();
        const end = start + durationDays * 24 * 60 * 60 * 1000;
        const now = Date.now();
        const diff = Math.max(0, end - now);

        const d = Math.floor(diff / (1000 * 60 * 60 * 24));
        const h = Math.floor((diff / (1000 * 60 * 60)) % 24);
        const m = Math.floor((diff / (1000 * 60)) % 60);

        return { d, h, m };
    };

    useEffect(() => {
        if (!startDate || !durationDays) return;

        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    setVisible(true);
                }
            },
            { threshold: 0.1 }
        );

        if (countdownRef.current) {
            observer.observe(countdownRef.current);
        }

        return () => {
            if (countdownRef.current) {
                observer.unobserve(countdownRef.current);
            }
        };
    }, []);

    useEffect(() => {
        if (!visible || !startDate || !durationDays) return;

        // 👇 Сразу вычисляем без задержки
        setTimeLeft(calculateTimeLeft());

        const interval = setInterval(() => {
            setTimeLeft(calculateTimeLeft());
        }, 1000);

        return () => clearInterval(interval);
    }, [visible, startDate, durationDays]);

    const isLoading = !timeLeft;

    return (
        <div
            ref={countdownRef}
            className="flex flex-row items-center gap-2 text-white font-thin"
        >
            {isLoading ? (
                <>
                    <SkeletonBox /> D <SkeletonBox /> H <SkeletonBox /> M
                </>
            ) : (
                <>
                    <ValueBox value={timeLeft.d} /> D
                    <ValueBox value={timeLeft.h} /> H
                    <ValueBox value={timeLeft.m} /> M
                </>
            )}
        </div>
    );
}

function SkeletonBox() {
    return (
        <div className="w-[25px] h-[25px] rounded bg-white/10 animate-pulse" />
    );
}

function ValueBox({ value }) {
    return (
        <div className="w-[25px] h-[25px] bg-white/10 rounded flex items-center justify-center">
            {value}
        </div>
    );
}
